import { Stat } from "@modules/home/data/mockData";
import { GridOverlay } from "./GridOverlay";
import { StatCard } from "./StatCard";

type StatsGridProps = {
  isInView: boolean;
  stats: Stat[];
};

export function StatsGrid({ isInView, stats }: StatsGridProps) {
  return (
    <div className="relative grid h-fit w-full grid-cols-2 place-items-center gap-px lg:w-auto lg:min-w-max">
      <GridOverlay />
      {stats.map((stat, index) => (
        <StatCard key={index} stat={stat} isInView={isInView} />
      ))}
    </div>
  );
}
